<template>
  <v-row>
    <v-col class="d-flex justify-center mt-5">
      <div class="user">
        <template v-if="person && person.file">
          <v-img :disabled="isDisabled" @click="$refs.FileInput.click()" :src="person.file.full_path" class="profile-img"/>
          <v-icon :disabled="isDisabled" @click="deleteFile" class="icon bg-primary text-white" icon="mdi-close" size="x-large"/>
        </template>
        <v-img v-else :disabled="isDisabled" @click="$refs.FileInput.click()" src="../../../assets/images/no-user.jpg" class="profile-img"/>
        <input :disabled="isDisabled" @change="onFileSelect" ref="FileInput" type="file" style="display: none"/>
      </div>
    </v-col>
  </v-row>
  <v-row v-if="person">
    <v-col class="text-center">
      <h3 class="text-primary">{{ person.name }}</h3>
      <div v-if="person.user && person.user.last_login">
        <PhSignIn size="16"/><span class="tiny-normal text-primary ml-2">{{ moment(person.user.last_login).format("DD-MM-YYYY HH:mm") }}</span>
      </div>
      <div v-if="person.mobilenumber">
        <PhDeviceMobile size="16"/><span class="tiny-normal text-primary ml-2">{{ person.mobilenumber }}</span>
      </div>
      <div v-if="person.phonenumber">
        <PhPhone size="16"/><span class="tiny-normal text-primary ml-2">{{ person.phonenumber }}</span>
      </div>
      <div v-if="person.billingnumber">
        <PhPhone size="16"/><span class="tiny-normal text-primary ml-2">{{ person.billingnumber }}</span>
      </div>
      <div v-if="person.user && person.user.email">
        <PhEnvelopeSimple size="16"/><span class="tiny-normal text-primary ml-2">{{ person.user.email }}</span>
      </div>
      <template v-for="email in person.emailaddresses">
        <div v-if="!person.user || email.emailaddress !== person.user.email">
          <PhEnvelopeSimple size="16"/><span class="tiny-normal text-primary ml-2">{{ email.emailaddress }}</span>
        </div>
      </template>
    </v-col>
  </v-row>
  <base-draggable-modal
      name="base_profile_photo"
      ref="base_profile_photo"
      :fullscreen="$vuetify.display.xsOnly"
      max-height="80vh"
      width="50vw">
    <v-card rounded="xl">
      <base-modal>
        <template #header>
          <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
            <v-toolbar-title class="text-primary">{{ $store.getters.translate("edit_avatar") }}</v-toolbar-title>
          </v-toolbar>
        </template>
        <template #content>
          <v-card-text>
            <vue-cropper v-show="selectedFile" ref="cropper" :src="selectedFile" alt="Source Image"/>
          </v-card-text>
        </template>
        <template #footer>
          <v-card-text>
            <v-row>
              <v-col>
                <base-action-button :width="'100%'" @action="closeModal('base_profile_photo')">
                  <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("close") }}
                </base-action-button>
              </v-col>
              <v-col>
                <base-action-button :background="true" :width="'100%'" @action="saveFile(); closeModal('base_profile_photo')">
                  <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("save") }}
                </base-action-button>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </base-modal>
    </v-card>
  </base-draggable-modal>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseModal from "./BaseModal";
import BaseDraggableModal from "./BaseDraggableModal";
import BaseActionButton from "./BaseActionButton";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import {PhDeviceMobile, PhEnvelopeSimple, PhFloppyDisk, PhPhone, PhSignIn, PhX} from "@phosphor-icons/vue";

export default {
  name: 'BaseProfilePhoto',
  components: {
    BaseActionButton,
    BaseModal,
    BaseDraggableModal,
    VueCropper,
    PhFloppyDisk, PhX, PhEnvelopeSimple, PhPhone, PhDeviceMobile, PhSignIn,
  },
  props: ["person", "isDisabled"],
  data() {
    return {
      mime_type: "",
      selectedFile: "",
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async saveFile() {
      this.$refs.cropper.getCroppedCanvas().toBlob(async (blob) => {
            const formData = new FormData();
            formData.append("attachment", blob);
            formData.append("person_id", this.person.id);
            await helpFunctions.saveFile(this.$toast, "people", formData);
            this.$emit('refresh');
          },
          this.mime_type);
    },
    async deleteFile() {
      this.$confirm(this.$store.getters.translate("confirm")).then(async (res) => {
        if (res) {
          await helpFunctions.deleteFile(this.$toast, "people", {person_id: this.person.id});
          this.$emit('refresh');
        }
      });
    },
    onFileSelect(e) {
      if (e.target.files[0]) {
        const file = e.target.files[0];
        this.mime_type = file.type;
        if (typeof FileReader === "function") {
          this.openModal('base_profile_photo');
          const reader = new FileReader();
          reader.onload = (event) => {
            this.selectedFile = event.target.result;
            this.$refs.cropper.replace(this.selectedFile);
          };
          reader.readAsDataURL(file);
        } else {
          alert("Sorry, FileReader API not supported");
        }
      }
    },
  },
};
</script>

<style scoped>
.user {
  width: 125px;
  height: 125px;
  border-radius: 100%;
  border: 3px solid lightgray;
  position: relative;
  text-align: center;
}
.profile-img {
  height: 100%;
  width: 100%;
  border-radius: 50%;
  cursor: pointer;
  margin-bottom: 10px;
}
.icon {
  position: absolute;
  top: 10px;
  right: 0;
  background: #e2e2e2;
  border-radius: 100%;
  width: 30px;
  height: 30px;
  line-height: 30px;
  vertical-align: middle;
  text-align: center;
  color: #0000ff;
  font-size: 14px;
  cursor: pointer;
}
</style>